/**
 * Build stamp — a small, muted line shown on every screen so a tester can
 * confirm exactly which deploy they are viewing. All three values are injected
 * at build time by vite.config.ts `define` (version from package.json, commit
 * from Netlify's COMMIT_REF or local git, plus the build timestamp).
 */
export function VersionTag(): JSX.Element {
  return (
    <p className="version" aria-label="build version">
      v{__APP_VERSION__} · {__BUILD_ID__} · {__BUILD_TIME__}
    </p>
  );
}
